import { IJobList } from './interfaces/IJob';
import { timestampToDate } from './utils/date';

// @ts-ignore
const gettext = window.gettext || ((text: string) => text);

const delay = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

const groupJobs = (jobs: IJobList[]) => {
    const sortedJobs = jobs.sort((a, b) => {
        const aTimestamp = a.dateStart;
        const bTimestamp = b.dateStart;
        return bTimestamp - aTimestamp;
    });

    return sortedJobs.reduce(
        (acc, job) => {
            const startDate = timestampToDate(job.dateStart);

            if (!acc[startDate]) {
                acc[startDate] = [];
            }
            acc[startDate].push(job);
            return acc;
        },
        {} as { [key: string]: IJobList[] }
    );
};

export { gettext, delay, groupJobs };
